module.exports = __webpack_public_path__ + "img/logo.24fdb3d6.png";